@if(hasData) {
<div class="case-overview-chart">
  <div class="case-overview-chart__plot">
    <apx-chart *ngIf="chartOptions?.series" [series]="chartOptions.series" [chart]="chartOptions.chart"
      [plotOptions]="chartOptions.plotOptions" [xaxis]="chartOptions.xaxis" [yaxis]="chartOptions.yaxis"
      [fill]="chartOptions.fill" [stroke]="chartOptions.stroke" [tooltip]="chartOptions.tooltip"
      [dataLabels]="chartOptions.dataLabels" [legend]="chartOptions.legend" [colors]="chartOptions.colors"
      [grid]="chartOptions.grid">
    </apx-chart>
  </div>
  <div class="case-overview-chart__footer">
    <div class="case-overview-chart__legend">
      <div class="case-overview-chart__legend-item">
        <span class="legend-dot" style="background-color: var(--mat-charts-color-one);"></span>
        <span>{{'dashboard.filed_cases' | translate}}</span>
      </div>
      <div class="case-overview-chart__legend-item">
        <span class="legend-dot" style="background-color: var(--mat-charts-color-two);"></span>
        <span>{{'dashboard.cash_reembursement' | translate}}</span>
      </div>
      <div class="case-overview-chart__legend-item">
        <span class="legend-dot" style="background-color: var(--mat-charts-color-three);"></span>
        <span>{{'dashboard.inventory_reembursement' | translate}}</span>
      </div>
    </div>
    <button type="button" mat-stroked-button color="primary" class="case-overview-chart__action"
      (click)="viewCases.emit()">
      {{ 'dashboard.view_cases' | translate }}
    </button>
  </div>
</div>
} @else {
<app-dashboard-chart-empty-state
  messageKey="dashboard.no_filed_cases"
  minHeight="10.25rem" />
}
